import serialize from '../../utils/serialize'
import { sortPrepayment } from '../../screens/PricePrepayment/PricePrepayment'

export default function updatePrepayment(api: GlobalFetch) {
  return async function(values, id_calendar) {
    const requestBody = {
      id_calendar,
      prepayment_type: values.prepayment_type,
      provision: serialize(sortPrepayment(values.provision, true)),
    }

    const buildUrl = `/api/v2/object/payment`
    const response = await api.fetch(buildUrl, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })
    const responseBody: IData = await response.json()

    return responseBody.items
  }
}

export interface IData {
  messages: string[]
  items: any
}
